import { useLocation } from 'react-router-dom';
import { Option } from './common-types';

export const isBoolean = (value: any) => {
	return value === false || value === true;
};

export const getRoleFromPathname = () => {
	// e.g., /accessioner/view/customers
	const { pathname } = useLocation();

	return pathname.split('/')[1];
};

export const getLabelFromValue = (value: string, options: Option[]) => {
	const formattedValue = value
		? value.trim().toLowerCase().replace(/\s/g, '_')
		: value;

	const option = options.filter(
		(option) => option.value === formattedValue || option.value === value
	);

	return option.length === 1 ? option[0].label : value;
};

/**
 * Converts a string to camelCase.
 *
 * @param str - The string to convert to camelCase
 * @returns The camelCase version of the string
 *
 * @example
 * ```typescript
 * toCamelCase('Received Date') // returns 'receivedDate'
 * toCamelCase('Hello World') // returns 'helloWorld'
 * ```
 */
export const toCamelCase = (str: string): string => {
	return str
		.split(' ')
		.map((word, index) => {
			if (index === 0) {
				return word.toLowerCase();
			}
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
		})
		.join('');
};
